'use client';
import { ChipStyled } from './chip.styles';

declare module '@mui/material/Chip' {
  interface ChipPropsColorOverrides {
    tertiary: true;
  }
}

const Chip = ChipStyled;

export default Chip;
